import "./styles/globals.scss";

import React from "react";
import { BrowserRouter } from "react-router-dom";

import { NotificationProvider } from "./context/NotificationContext";
import RootRouter from "./router/routes";

const App = () => {
  return (
    <NotificationProvider>
      <BrowserRouter>
        <RootRouter />
      </BrowserRouter>
    </NotificationProvider>
  );
};

// add reset to all ides

export default App;
